define('commons/quick-actions',['jquery'], function($) {
    
    var QuickActions = function( containers, options ) {
        this.$openedContainer = null;
        this.settings = $.extend({
            onActionsMenuOpen : null,
            quickActionsUrl : '${id}/actions'
        }, options);
        this.enhance( containers );
    };
    
    QuickActions.prototype.enhance = function( containers ){
        var $containers = $(containers);
        var here = this;
        // Hover effect
        $containers.addClass('quick-action-wrapper');

        // Show menu
        $containers.on('click.quickActions', function(e){
            // Clicked element is a link/input (selector..), don't show the menu
            if ($(e.target).closest('a,input').length) {
                return true;
            }
            e.stopImmediatePropagation();
            
            // Menu is opened 
            if( here.$openedContainer ){
                $(document).off('.quickActions');
                here.$openedContainer.removeClass('opened');
                here.$openedContainer = null;
                // close it and go
                $('#quick-actions-menu').remove();
                return false;
            }
            
            here.$openedContainer = $(this);
            here.$openedContainer.addClass('opened');
            var  id = here.$openedContainer.data('object-id');
            
            if(id){
                var $menu = $('<ul id="quick-actions-menu" class="quick-actions"></ul>');
                $menu.attr('data-object-id', id);
                $menu.css('top', e.pageY);
                $menu.css('left', e.pageX);
                $.ajax({
                    type: 'GET',
                    url: here.settings.quickActionsUrl.replace('${id}', id),
                    success: function(data) {
                        // Empty content
                        if(/^\s*$/.test(data)){
                            here.$openedContainer.removeClass('opened');
                            here.$openedContainer = null;
                            return;
                        }
                        // Creates and inserts each <li><a href='...'>Link</a></li> in the menu
                        $(data).filter('a').map( function(i, val){
                            $menu.append( $('<li class="quick-action"></li>').append( $(val)) );
                        });
                        $('body').append($menu);
                        // Hide menu
                        $(document).one('click.quickActions keyup.quickActions', function(e){
                            if (e.type === 'click' || e.keyCode == 27) {
                                if( here.$openedContainer ){
                                    here.$openedContainer.removeClass('opened');
                                    here.$openedContainer = null;
                                    $('#quick-actions-menu').remove();
                                }
                            }
                        });
                        
                        here.settings.onActionsMenuOpen && here.settings.onActionsMenuOpen( $menu );
                    }
                });
            }
        });
        
    };
    
    return QuickActions;
});
